var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.results.length > 0)?_c('div',[_vm._t("default",function(){return [_vm._t("results",function(){return [_vm._l((_vm.results),function(result,index){return _vm._t("result",null,{"result":result,"resultCount":_vm.resultCount,"index":index})})]},{"results":_vm.results,"resultCount":_vm.resultCount})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }